import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const ModalContainer = styled.div`
  padding: ${pxToRem('48px')} 0;
`;

export const ModalData = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ModalContent = styled.div`
  text-align: center;
  border-radius: ${pxToRem('30px')};
  background-color: ${props => props.theme.colors.white};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: ${pxToRem('20px')};
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: ${pxToRem('20px')};
  margin-bottom: ${pxToRem('10px')};
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${pxToRem('60px')};
  gap: ${pxToRem('20px')};
`;
